module.exports = __webpack_public_path__ + "static/img/4.553434a5.png";